import React, { useEffect, useState } from "react";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import NewRegistrationModal from "components/Private/NewRegistrationModal";
import Swal from 'sweetalert2';
import EditGuestModal from "components/Private/EditGuestModal";
import { useGuestContext } from '../../contexts/GuestContext';
import Event3R5PTable from "./Event3R5PTable";
// react-bootstrap components
import {
    Modal,
    Button,
    Card,
    Nav,
    Container,
    Dropdown,
    Row,
    Col,
    OverlayTrigger, Tooltip
} from "react-bootstrap";
import SheetUpload from "components/Private/SheetUpload";
// core components
import ReactTable from "../../components/ReactTable/ReactTable";

// Event configuration for scalable event management
const EVENT_CONFIG = {
    'vegefest': {
        displayName: '素食展',
        fullName: '素食展',
        hasTable: true,
        tableComponent: 'ReactTable'
    },
    'budhabath': {
        displayName: '浴佛節暨夏安居報恩藥師啟建法會',
        fullName: '浴佛節暨夏安居報恩藥師啟建法會',
        hasTable: true,
        tableComponent: 'ReactTable'
    },
    'newyear': {
        displayName: '新年法會',
        fullName: '新年法會',
        hasTable: true,
        tableComponent: 'ReactTable'
    },
    'chingming': {
        displayName: '藥師法會',
        fullName: '藥師寶懺法會',
        hasTable: true,
        tableComponent: 'ReactTable'
    }
};

// Helper function to get event display name
const getEventDisplayName = (eventKey) => {
    return EVENT_CONFIG[eventKey]?.displayName || '未選擇法會';
};

// Helper function to get event full name
const getEventFullName = (eventKey) => {
    return EVENT_CONFIG[eventKey]?.fullName || '法會未選擇';
};

function EventRegAdmin() {
    const [refreshDataTrigger, setRefreshDataTrigger] = useState(0);
    const { language, setPageBanner, setLoading, viewingEvent, switchEvent, switchSession, selectedSession } = useGuestContext();
    const [modal, setModal] = React.useState(false);
    const [uploadModal, setUploadModal] = React.useState(false);
    const [editGuestModal, setEditGuestModal] = React.useState(false);
    const [alert, setAlert] = React.useState(null);
    const [registrations, setRegistrations] = useState([]); // state for holding fetched data
    const [selectedRegistration, setSelectedRegistration] = useState(null);

    const hideAlert = () => {
        setAlert(null);
    };

    const handleEditClick = (guestId, response) => {
        console.log('Edit clicked for guest:', guestId);
        const registrationData = response.data.find(registration => registration.id === guestId);

        setSelectedRegistration(registrationData);
        setEditGuestModal(!editGuestModal);
    };

    const handleResendNotificationClick = async (guestId) => {
        const url = `${process.env.REACT_APP_SERVER_URL}/${viewingEvent}/resend-notification/${guestId}`;
        try {
            const response = await axios.post(url, {
                // Include any required data in the request body
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    // Include other headers as required, like authorization tokens
                }
            });
            // Handle response
            console.log('Notification resend successful', response.data);
            successNotificationResent(guestId)
            // You can process the response data as needed
        } catch (error) {
            // Handle errors from the request
            console.error('Error when trying to resend notification:', error.response ? error.response.data : error.message);
        }
    };

    const resendNotificationConfirm = (guestId) => {
        console.log('Resend notification clicked for guest:', guestId);
        // Handle the check-in logic
        const htmlContent = language === "English" ?
            `Are you sure you want to send the notification to <strong style="color: #007bff;">Guest ID: ${guestId}</strong>?` :
            `您確定要向 <strong style="color: #007bff;">Guest ID：${guestId}</strong> 發送通知嗎？`;

        Swal.fire({
            title: language === "English" ? "Send Notification" : "發送通知",
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? "Yes, Send It" : "是的，發送",
            cancelButtonText: language === "English" ? "Cancel" : "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                handleResendNotificationClick(guestId); // Call function to send notification
            } else {
                hideAlert(); // Hide the alert if cancelled
            }
        });
    };

    const handleCheckInClick = (guestId) => {
        console.log('Check-in clicked for guest:', guestId);
        // For non-newyear events, use existing flow
        Swal.fire({
            title: 'Check-in Guest',
            html: `
                <p>Do you want to check-in Guest ID: <strong>${guestId}</strong>?</p>
                <div style="margin-top: 20px;">
                    <label for="groupSizeInput" style="display: block; margin-bottom: 10px; font-weight: bold; color: #333;">
                        ${language === "English" ? "Actual Group Size (實際到場人數):" : "實際到場人數:"}
                    </label>
                    <select id="groupSizeInput" class="swal2-select" style="
                        width: 120px; 
                        padding: 12px 16px; 
                        border: 2px solid #e1e5e9; 
                        border-radius: 8px; 
                        font-size: 16px; 
                        background-color: #fff; 
                        color: #333; 
                        cursor: pointer;
                        transition: border-color 0.3s ease;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        text-align: center;
                    " onfocus="this.style.borderColor='#007bff'" onblur="this.style.borderColor='#e1e5e9'">
                        <option value="">${language === "English" ? "Select group size" : "選擇人數"}</option>
                        ${Array.from({ length: 15 }, (_, i) => `<option value="${i + 1}">${i + 1}</option>`).join('')}
                    </select>
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? 'Yes, check them in!' : '是的，確認報到',
            cancelButtonText: language === "English" ? 'Cancel' : '取消',
            preConfirm: () => {
                const groupSize = document.getElementById('groupSizeInput').value;
                if (!groupSize) {
                    Swal.showValidationMessage(language === "English" ? 'Please select a group size' : '請選擇人數');
                    return false;
                }
                return parseInt(groupSize);
            }
        }).then((result) => {
            if (result.isConfirmed) {
                checkInGuest(guestId, result.value);
            }
        });
    };

    // Unified New Year check-in modal - shows status of both events and allows check-in/un-check-in
    const handleNewYearManageCheckIn = async (registration) => {
        const guestId = registration.id;
        const ev1CheckedIn = !!registration.checkedInEvent1;
        const ev2CheckedIn = !!registration.checkedInEvent2;
        const ev1GroupSize = registration.checkedInGroupSizeEvent1 || 0;
        const ev2GroupSize = registration.checkedInGroupSizeEvent2 || 0;

        const getBoxStyle = (isCheckedIn) => `
            padding: 20px 24px;
            border: 2px solid ${isCheckedIn ? '#28a745' : '#ccc'};
            border-radius: 10px;
            cursor: pointer;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            transition: all 0.2s ease;
            user-select: none;
            background-color: ${isCheckedIn ? '#d4edda' : 'white'};
            color: ${isCheckedIn ? '#155724' : '#333'};
        `;

        const getStatusLabel = (isCheckedIn, groupSize) => {
            if (isCheckedIn) {
                return `<div style="font-size: 13px; margin-top: 6px; color: #155724;">✅ 已報到 (隨行 ${groupSize} 人)</div>`;
            }
            return `<div style="font-size: 13px; margin-top: 6px; color: #999;">未報到</div>`;
        };

        const { value: result } = await Swal.fire({
            title: `報到管理 - Guest ${String(guestId).padStart(4, '0')}`,
            html: `
                <input type="hidden" id="selectedEvent" value="">
                <input type="hidden" id="selectedAction" value="">
                <p style="font-size: 14px; color: #666; margin-bottom: 16px;">點選法會以報到或取消報到</p>
                <div style="display: flex; flex-direction: column; gap: 16px; padding: 10px 0;">
                    <div id="event-box-1" class="event-box" data-event="1" data-checked="${ev1CheckedIn}" style="${getBoxStyle(ev1CheckedIn)}">
                        歲末祈福法會
                        ${getStatusLabel(ev1CheckedIn, ev1GroupSize)}
                    </div>
                    <div id="event-box-2" class="event-box" data-event="2" data-checked="${ev2CheckedIn}" style="${getBoxStyle(ev2CheckedIn)}">
                        新春合禮團拜會
                        ${getStatusLabel(ev2CheckedIn, ev2GroupSize)}
                    </div>
                </div>
                <div id="action-hint" style="margin-top: 12px; font-size: 14px; font-weight: 500; color: #666; min-height: 24px;"></div>
            `,
            didOpen: () => {
                const boxes = Swal.getPopup().querySelectorAll('.event-box');
                const hiddenEvent = Swal.getPopup().querySelector('#selectedEvent');
                const hiddenAction = Swal.getPopup().querySelector('#selectedAction');
                const actionHint = Swal.getPopup().querySelector('#action-hint');
                const confirmBtn = Swal.getConfirmButton();

                // Initially hide confirm since nothing selected
                confirmBtn.style.display = 'none';

                boxes.forEach(box => {
                    box.addEventListener('click', () => {
                        const eventNum = box.dataset.event;
                        const isCurrentlyCheckedIn = box.dataset.checked === 'true';

                        // Reset all boxes to their original state
                        boxes.forEach(b => {
                            const bCheckedIn = b.dataset.checked === 'true';
                            if (bCheckedIn) {
                                b.style.backgroundColor = '#d4edda';
                                b.style.color = '#155724';
                                b.style.borderColor = '#28a745';
                            } else {
                                b.style.backgroundColor = 'white';
                                b.style.color = '#333';
                                b.style.borderColor = '#ccc';
                            }
                        });

                        // Highlight the clicked box based on action
                        if (isCurrentlyCheckedIn) {
                            // Will un-check-in → red
                            box.style.backgroundColor = '#f8d7da';
                            box.style.color = '#721c24';
                            box.style.borderColor = '#d33';
                            hiddenAction.value = 'uncheckin';
                            actionHint.innerHTML = `<span style="color: #d33;">→ 將取消「${eventNum === '1' ? '歲末祈福法會' : '新春合禮團拜會'}」的報到</span>`;
                            confirmBtn.style.display = '';
                            confirmBtn.textContent = '確認取消報到';
                            confirmBtn.style.backgroundColor = '#d33';
                            confirmBtn.style.borderColor = '#d33';
                        } else {
                            // Will check-in → blue
                            box.style.backgroundColor = '#cce5ff';
                            box.style.color = '#004085';
                            box.style.borderColor = '#3085d6';
                            hiddenAction.value = 'checkin';
                            actionHint.innerHTML = `<span style="color: #3085d6;">→ 將報到「${eventNum === '1' ? '歲末祈福法會' : '新春合禮團拜會'}」</span>`;
                            confirmBtn.style.display = '';
                            confirmBtn.textContent = '下一步';
                            confirmBtn.style.backgroundColor = '#3085d6';
                            confirmBtn.style.borderColor = '#3085d6';
                        }

                        hiddenEvent.value = eventNum;
                    });
                });
            },
            preConfirm: () => {
                const selectedEvent = document.getElementById('selectedEvent').value;
                const selectedAction = document.getElementById('selectedAction').value;
                if (!selectedEvent) {
                    Swal.showValidationMessage('請選擇一個法會！');
                    return false;
                }
                return { event: selectedEvent, action: selectedAction };
            },
            showCancelButton: true,
            confirmButtonText: '下一步',
            cancelButtonText: '關閉'
        });

        if (!result) return;

        const eventNumber = parseInt(result.event);
        const eventName = eventNumber === 1 ? '歲末祈福法會' : '新春合禮團拜會';

        if (result.action === 'uncheckin') {
            // Un-check-in flow
            try {
                await axios.get(`${process.env.REACT_APP_SERVER_URL}/newyear/uncheckIn?guestid=${guestId}&event=${eventNumber}`);
                Swal.fire({
                    title: '已取消報到',
                    text: `Guest ID: ${guestId}「${eventName}」的報到已取消。`,
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => window.location.reload());
            } catch (error) {
                Swal.fire({ title: '取消失敗', text: `取消報到時出現問題，請重試。`, icon: 'error', confirmButtonText: 'OK' });
                console.error('Reverse check-in failed:', error);
            }
        } else {
            // Check-in flow → ask for group size
            const { value: groupSize } = await Swal.fire({
                title: `報到「${eventName}」- 選擇隨行人數`,
                input: 'select',
                inputOptions: {
                    '0': '0', '1': '1', '2': '2', '3': '3', '4': '4',
                    '5': '5', '6': '6', '7': '7', '8': '8', '9': '9', '10': '10'
                },
                inputPlaceholder: '選擇人數',
                showCancelButton: true,
                confirmButtonText: '確認報到',
                cancelButtonText: '取消',
                inputValidator: (value) => {
                    if (value === '') return '請選擇隨行人數！';
                }
            });

            if (groupSize === undefined || groupSize === null) return;

            try {
                await axios.post(`${process.env.REACT_APP_SERVER_URL}/newyear/checkinconfirm`, {
                    guestid: guestId,
                    event: eventNumber,
                    groupSize: parseInt(groupSize)
                });
                Swal.fire({
                    title: '報到成功！',
                    text: `Guest ID: ${guestId} 已報到「${eventName}」，隨行人數: ${groupSize}`,
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => window.location.reload());
            } catch (error) {
                Swal.fire({ title: '報到失敗', text: `報到時出現問題，請重試。`, icon: 'error', confirmButtonText: 'OK' });
                console.error('Check-in failed:', error);
            }
        }
    };

    const checkInGuest = async (guestId, groupSize) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/${viewingEvent}/checkinconfirm`, {
                guestid: parseInt(guestId, 10),
                groupSize: groupSize
            });
            Swal.fire({
                title: language === "English" ? 'Success!' : '成功！',
                text: language === "English"
                    ? `Guest ID: ${guestId} has been successfully checked in${groupSize ? ' with group size: ' + groupSize : ''}.`
                    : `Guest ID: ${guestId} 已成功報到${groupSize ? '，實際到場人數: ' + groupSize : ''}。`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            }).then(() => {
                window.location.reload();
            });
        } catch (error) {
            Swal.fire({
                title: language === "English" ? 'Failed to Check-in' : '報到失敗',
                text: language === "English"
                    ? `There was a problem checking in Guest ID: ${guestId}. Please try again.`
                    : `Guest ID: ${guestId} 報到時出現問題，請重試。`,
                icon: 'error',
                confirmButtonColor: '#d33',
                confirmButtonText: 'OK'
            });
            console.error('Check-in failed:', error);
        }
    };

    const handleCheckinReset = async () => {
        // Ask for confirmation using SweetAlert2
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to reset all check-ins?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, reset it!',
            cancelButtonText: 'No, cancel',
            reverseButtons: true,
        });

        if (result.isConfirmed) {
            const url = `${process.env.REACT_APP_SERVER_URL}/${viewingEvent}/clearcheckin`; // Adjust the URL to your setup

            try {
                const response = await axios.post(url, { action: 'clear_checkins' }, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                // Show success message using SweetAlert2
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message, // The success message from the backend
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            } catch (error) {
                // Show error message using SweetAlert2
                const errorMessage = error.response ? error.response.data.detail : error.message;
                Swal.fire({
                    title: 'Error!',
                    text: `Failed to reset check-ins: ${errorMessage}`,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } else {
            // User clicked "Cancel" in the confirmation dialog
            Swal.fire({
                title: 'Cancelled',
                text: 'Check-in reset was cancelled.',
                icon: 'info',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleReverseCheckInClick = (guestId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to revert the check-in status for Guest ID: ${guestId}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, revert it!'
        }).then((result) => {
            if (result.isConfirmed) {
                reverseCheckInGuest(guestId);
            }
        });
    };

    const reverseCheckInGuest = async (guestId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/${viewingEvent}/uncheckIn?guestid=${guestId}`);
            Swal.fire({
                title: 'Reversed!',
                text: `The check-in for Guest ID: ${guestId} has been reversed.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            }).then(() => {
                window.location.reload();
            });
        } catch (error) {
            Swal.fire({
                title: 'Failed to Reverse',
                text: `There was a problem reversing the check-in for Guest ID: ${guestId}. Please try again.`,
                icon: 'error',
                confirmButtonColor: '#d33',
                confirmButtonText: 'OK'
            });
            console.error('Reverse check-in failed:', error);
        }
    };



    const handleDeleteClick = (guestId) => {
        const htmlContent = language === "English" ?
            `Are you sure you would like to delete the registration of <strong style="color: #007bff;">Guest ID: ${guestId}</strong>?` :
            `您確定要刪除 <strong style="color: #007bff;">Guest ID：${guestId}</strong> 的報名嗎？`;

        Swal.fire({
            title: language === "English" ? "Delete Confirmation" : "確認要刪除嗎？",
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? "Confirm Deletion" : "確認刪除報名",
            cancelButtonText: language === "English" ? "Cancel" : "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteRegistration(guestId);
            } else {
                hideAlert();
            }
        });
    };

    const successNotificationResent = (guestId) => {
        const htmlContent = language === "English" ?
            `Email successfully sent to <strong style="color: #007bff;">Guest ID: ${guestId}</strong>.` :
            `已成功向 <strong style="color: #007bff;">Guest ID：${guestId}</strong> 發送電子郵件。`;

        Swal.fire({
            title: language === "English" ? "Email Sent!" : "電子郵件已發送！",
            html: htmlContent,
            icon: 'success',
            confirmButtonColor: '#17a2b8', // Using a color for the confirm button (Bootstrap's info color)
            confirmButtonText: language === "English" ? "OK" : "好的"
        }).then(() => {
            hideAlert(); // Hide the alert after acknowledging
        });
    };

    const successDelete = (guestId) => {
        const htmlContent = language === "English" ?
            `The registration of <strong style="color: #007bff;">Guest ID: ${guestId}</strong> is deleted.` :
            `<strong style="color: #007bff;">Guest ID：${guestId}</strong> 的報名已被刪除。`;

        Swal.fire({
            title: "Deleted!",
            html: htmlContent,
            icon: 'success',
            confirmButtonColor: '#17a2b8', // Using a color for the confirm button (Bootstrap's info color)
            confirmButtonText: language === "English" ? "OK" : "好的"
        }).then(() => {
            hideAlert();
        });
    };

    const deleteRegistration = async (guestId) => {
        try {
            setLoading(true); // Start loading (if you have a loading state)
            await axios.delete(`${process.env.REACT_APP_SERVER_URL}/${viewingEvent}/delete-registration/${guestId}`);
            successDelete(guestId);
            setLoading(false); // Stop loading (if you have a loading state)
            setRefreshDataTrigger(prev => prev + 1);
        } catch (error) {
            console.error('Error deleting registration:', error);
            setLoading(false); // Stop loading (if you have a loading state)
            // Handle error here, maybe show an error alert
        }
    }

    useEffect(() => {
        const fetchRegistrations = async () => {
            try {
                setLoading(true); // If you have a loading state

                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/${viewingEvent}/getregistration`);
                const formattedData = response.data.map((registration) => {
                    // For newyear: single unified button that opens smart modal
                    // For other events: separate check-in / reverse buttons
                    let checkInButton;
                    if (viewingEvent === 'newyear') {
                        const anyCheckedIn = registration.checkedInEvent1 || registration.checkedInEvent2;
                        checkInButton = (
                            <Button
                                size="sm"
                                className={`${anyCheckedIn ? 'btn-warning' : 'text-success'} btn-link like`}
                                onClick={() => handleNewYearManageCheckIn(registration)}
                            >
                                <OverlayTrigger overlay={<Tooltip>報到管理</Tooltip>}>
                                    <FontAwesomeIcon icon={faCircleCheck} />
                                </OverlayTrigger>
                            </Button>
                        );
                    } else {
                        const isCheckedIn = registration.checkedIn && registration.checkedInTime;
                        checkInButton = isCheckedIn ? (
                            <Button
                                size="sm"
                                className="btn-warning btn-link like"
                                onClick={() => handleReverseCheckInClick(registration.id)}
                            >
                                <OverlayTrigger overlay={<Tooltip>Reverse Guest Check-in</Tooltip>}>
                                    <FontAwesomeIcon icon={faCircleCheck} />
                                </OverlayTrigger>
                            </Button>
                        ) : (
                            <Button
                                size="sm"
                                className="text-success btn-link like"
                                onClick={() => handleCheckInClick(registration.id)}
                            >
                                <OverlayTrigger overlay={<Tooltip>Check-in Guest</Tooltip>}>
                                    <FontAwesomeIcon icon={faCircleCheck} />
                                </OverlayTrigger>
                            </Button>
                        );
                    }

                    return {
                        id: String(registration.id).padStart(4, '0'),
                        name: `${registration.firstname} ${registration.lastname}`,
                        phone: registration.phone,
                        // isVolunteering: registration.isVolunteering ? "Yes" : "No",
                        chineseName: registration.chinesename,
                        event1: registration.event1,
                        event2: registration.event2,
                        headcountEvent1: registration.headcountEvent1,
                        headcountEvent2: registration.headcountEvent2,
                        groupSize: registration.relatives,
                        checkInGroupSize: registration.checkInGroupSize,
                        actions: (
                            <div className="actions-right">
                                <Button
                                    onClick={() => handleEditClick(registration.id, response)}
                                    size="sm"
                                    className="text-warning btn-link edit"
                                >
                                    <OverlayTrigger overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}>
                                        <i className="fa fa-edit" />
                                    </OverlayTrigger>
                                </Button>{" "}
                                <Button
                                    onClick={() => resendNotificationConfirm(registration.id)}
                                    size="sm"
                                    className="text-info btn-link like"
                                >
                                    <OverlayTrigger overlay={<Tooltip id="resend-tooltip">Resend Notification</Tooltip>}>
                                        <FontAwesomeIcon icon={faPaperPlane} />
                                    </OverlayTrigger>
                                </Button>{" "}
                                {checkInButton}
                                <Button
                                    onClick={() => handleDeleteClick(registration.id)}
                                    variant="danger"
                                    size="sm"
                                    className="btn-link remove text-danger"
                                >
                                    <OverlayTrigger overlay={<Tooltip id="delete-tooltip">Delete Guest Registration</Tooltip>}>
                                        <i className="fa fa-times" />
                                    </OverlayTrigger>
                                </Button>{" "}
                            </div>
                        )
                    };
                });
                setRegistrations(formattedData);
                setLoading(false); // Stop loading indicator
            } catch (error) {
                console.error('Error fetching registration data:', error);
                setLoading(false); // Stop loading indicator
            }
        };
        viewingEvent && EVENT_CONFIG[viewingEvent]?.hasTable && fetchRegistrations();
    }, [refreshDataTrigger, viewingEvent]);

    const handleDownloadRegistration = async (e) => {
        e.preventDefault(); // Prevent default anchor behavior

        try {
            // Replace 'http://localhost:8000' with the actual base URL of your FastAPI server
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/${viewingEvent}/send-anniversary-data`);

            // Handle response here. For example, you could display a success message
            console.log('Success:', response.data);
        } catch (error) {
            // Handle error here. For example, display an error message
            console.error('Error fetching data:', error);
        }
    };

    const eventSelectionAlert = () => {
        // Generate inputOptions from EVENT_CONFIG
        const inputOptions = Object.keys(EVENT_CONFIG).reduce((options, eventKey) => {
            options[eventKey] = EVENT_CONFIG[eventKey].displayName;
            return options;
        }, {});

        Swal.fire({
            title: 'Select an event',
            input: 'select',
            inputOptions: inputOptions,
            inputPlaceholder: 'Select an event',
            inputValue: viewingEvent, // Preselect the current event
            showCancelButton: true,
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value !== '') {
                        resolve();
                    } else {
                        resolve('You need to select an event');
                    }
                });
            }
        }).then((result) => {

            if (result.isConfirmed && result.value !== viewingEvent) {
                const selectedText = getEventDisplayName(result.value);
                switchEvent(result.value); // Update the viewingEvent in the context
                console.log(result.value);
                console.log(viewingEvent);
                switchEvent(result.value); // Update any additional state or context as necessary
                Swal.fire(`切換至 ${selectedText} 的註冊表格`);
                // Optionally, update the page banner or any other relevant state here
            }
        });
    };

    const dropdownContent = (
        <>
            <Dropdown as={Nav.Item}>
                <Dropdown.Toggle as={Button} variant="info" className="btn-wd mr-1 btn-outline font-weight-bold" id="regPageAction">
                    Actions
                    <span className="dropdown-arrow ml-2">
                        <i className="nc-icon nc-minimal-down"></i>
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu alignRight aria-labelledby="navbarDropdownMenuLink">
                    <Dropdown.Item className="text-default" href="#pablo" onClick={handleDownloadRegistration}>
                        <i className="nc-icon nc-cloud-download-93"></i>
                        發送表格到郵箱
                    </Dropdown.Item>
                    <Dropdown.Item className="text-default" href="/guest">
                        <i className="nc-icon nc-badge"></i>
                        法會報名
                    </Dropdown.Item>
                    <Dropdown.Item className="text-default" href="#pablo" onClick={eventSelectionAlert}>
                        <i className="nc-icon nc-notes"></i>
                        選擇法會
                    </Dropdown.Item>
                    {/* <Dropdown.Item className="text-default" href="#pablo" onClick={sessionSelectionAlert}>
                        <i className="nc-icon nc-badge"></i>
                        選擇當期日期
                    </Dropdown.Item> */}
                    <Dropdown.Item className="text-default" href="#pablo" onClick={handleCheckinReset}>
                        <i className="nc-icon nc-badge"></i>
                        重置當前Check-in
                    </Dropdown.Item>
                    <Dropdown.Item className="text-default" href="#pablo" onClick={() => setUploadModal(!uploadModal)}>
                        <i className="nc-icon nc-cloud-upload-94"></i>
                        批量上傳
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
    return (
        <>
            {alert}
            {/* {alertState} */}
            <Container fluid>
                <Row>
                    <Col md="12">
                        <Card>
                            <Card.Header>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h4 className="title font-weight-bold">法會報名管理</h4>
                                    {dropdownContent}
                                </div>
                                <p className="category">
                                    當前瀏覽的是<span className="font-weight-bold text-primary">{getEventFullName(viewingEvent)}</span>的報名列表
                                </p>
                                {/* <p className="category">
                                    當前Check-in Session 是
                                    <span className="font-weight-bold text-primary">
                                        {selectedSession}: {sessionOptions[selectedSession]}
                                    </span>
                                    的報名列表
                                </p> */}
                            </Card.Header>
                            <hr />
                            <Card.Body>
                                {viewingEvent && EVENT_CONFIG[viewingEvent] ? (
                                    EVENT_CONFIG[viewingEvent].tableComponent === 'ReactTable' ? (
                                        <ReactTable
                                            data={registrations}
                                            columns={viewingEvent === 'newyear' ? [
                                                {
                                                    Header: "Guest ID",
                                                    accessor: "id",
                                                },
                                                {
                                                    Header: "Full Name",
                                                    accessor: "name",
                                                },
                                                {
                                                    Header: "歲末",
                                                    accessor: "event1",
                                                    Cell: ({ value }) => (
                                                        <div style={{ textAlign: 'center' }}>
                                                            {value ? "✓" : "-"}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    Header: "新春",
                                                    accessor: "event2",
                                                    Cell: ({ value }) => (
                                                        <div style={{ textAlign: 'center' }}>
                                                            {value ? "✓" : "-"}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    Header: "Phone",
                                                    accessor: "phone",
                                                },
                                                {
                                                    Header: "歲末 報名人數",
                                                    accessor: "headcountEvent1",
                                                    Cell: ({ value }) => (
                                                        <div style={{ textAlign: 'center' }}>
                                                            {value || '-'}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    Header: "新春 報名人數",
                                                    accessor: "headcountEvent2",
                                                    Cell: ({ value }) => (
                                                        <div style={{ textAlign: 'center' }}>
                                                            {value || '-'}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    Header: "實際到場人數",
                                                    accessor: "checkInGroupSize",
                                                    Cell: ({ value }) => (
                                                        <div style={{ textAlign: 'center' }}>
                                                            {value || '-'}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    Header: "Actions",
                                                    accessor: "actions",
                                                    sortable: false,
                                                    filterable: false,
                                                },
                                            ] : [
                                                {
                                                    Header: "Guest ID",
                                                    accessor: "id",
                                                },
                                                {
                                                    Header: "Full Name",
                                                    accessor: "name",
                                                },
                                                {
                                                    Header: "Chinese Name",
                                                    accessor: "chineseName",
                                                },
                                                {
                                                    Header: "Phone",
                                                    accessor: "phone",
                                                },
                                                {
                                                    Header: "報名人數",
                                                    accessor: "groupSize",
                                                    Cell: ({ value }) => (
                                                        <div style={{ textAlign: 'center' }}>
                                                            {value}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    Header: "實際到場人數",
                                                    accessor: "checkInGroupSize",
                                                    Cell: ({ value }) => (
                                                        <div style={{ textAlign: 'center' }}>
                                                            {value || '-'}
                                                        </div>
                                                    ),
                                                },
                                                {
                                                    Header: "Actions",
                                                    accessor: "actions",
                                                    sortable: false,
                                                    filterable: false,
                                                },
                                            ]}
                                            className="-striped -highlight primary-pagination"
                                        />
                                    ) : EVENT_CONFIG[viewingEvent].tableComponent === 'Event3R5PTable' ? (
                                        <Event3R5PTable data={registrations} />
                                    ) : (
                                        <p>Event table for {getEventDisplayName(viewingEvent)} will be implemented here.</p>
                                    )
                                ) : (
                                    <p>Please select an event to view the registration list.</p>
                                )}

                            </Card.Body>

                        </Card>
                    </Col>
                </Row>
            </Container>
            <NewRegistrationModal modal={modal} setModal={setModal} />
            <SheetUpload uploadModal={uploadModal} setUploadModal={setUploadModal} />
            <EditGuestModal editGuestModal={editGuestModal} setEditGuestModal={setEditGuestModal} registrationData={selectedRegistration} viewingEvent={viewingEvent} />
        </>
    );
}
export default EventRegAdmin;
